const Dummy = (props) => {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1194 843"
      {...props}
    >
      <path
        id="ENVIRONMENT_BACKGROUND"
        style={{
          fill: '#f6f',
        }}
        d="M0 0h1194v843H0z"
      />
    </svg>
  )
}

export default Dummy
